import { Injectable } from '@angular/core';
import emailjs from 'emailjs-com';

@Injectable({
  providedIn: 'root'
})
export class EmailsendService {

  constructor() { }

  sendEmail(codeRastreo: string, email: string, name: string, productos: any, total: string, gastosenvio: string) {
    
    const listaFormateada = productos.flatMap(grupo => grupo.items) // Entra a cada 'items' y los une todos
      .map(p => `${p.nombre}: ${p.descripcion} - $${p.precio}`) // Formatea cada producto
      .join("\n");
      
    const templateParams = {
      codeRastreo: codeRastreo,
      email: email,
      name: name,
      products: listaFormateada,
      subtotal: Number(total).toFixed(2).toString(),
      gastosenvio: Number(gastosenvio).toFixed(2).toString(),
      total: (Number(total) + Number(gastosenvio)).toFixed(2).toString()
    };

    emailjs.send(
      'service_l5lkcp5',
      'template_a1pytz5',
      templateParams,
      'qmbmi_fHJX5C6ZzML'
    )
    .then((response) => {
      console.log('Correo enviado con éxito!', response.status, response.text);
    })
    .catch((err) => {
      console.error('Error al enviar el correo:', err);
    });
  }

}
